export default __webpack_public_path__ + "static/mongodb-ec83371b2a11763d4acc89bd7c92025c.svg";